import { useQuery } from '@apollo/client';

import GET_CURRENT_USER_ORGANIZATION from './graphql/CurrentUserOrganization.b2b.graphql';
import type { CurrentUserOrganization } from './graphql/types/CurrentUserOrganization';

const useConfiguration = () => {
  const { data, loading } = useQuery<CurrentUserOrganization>(
    GET_CURRENT_USER_ORGANIZATION,
    {
      context: { clientName: 'b2b' },
    },
  );

  return {
    isLoadingCurrentUser: loading,
    currentUser: data?.currentUserOrganization,
  };
};

export default useConfiguration;
